import React from 'react';
import { Box } from '@mui/material';
import { Breadcrumbs } from '../../../components/shared';
import { routeConstants } from '../../../constants/routeConstants';
import useStyles from './style';
import MonthlyReconciliationControlPanel from './components/MonthlyReconciliationControlPanel';
import MonthlyFinalizeDialogs from './components/MonthlyFinalizeDialogs';
import MonthlyReconciliationResults from './components/MonthlyReconciliationResults';
import MonthlyReconciliationSummary from './components/MonthlyReconciliationSummary';
import MonthlyValidationDialog from './components/MonthlyValidationDialog';
import { useMonthlyReconciliationDetailController } from './hooks/useMonthlyReconciliationDetailController';

const MonthlyReconciliationDetail = ({ embedInOpenTab = false, breadcrumbSecondLabel = null }) => {
  const classes = useStyles();
  const { controlPanelProps, summaryProps, resultsProps, finalizeDialogProps, validationDialogProps } =
    useMonthlyReconciliationDetailController();

  return (
    <>
      <React.Fragment>
        {breadcrumbSecondLabel && (
          <Box mb={3}>
            <Breadcrumbs
              variant="body2"
              underline="hover"
              data={[
                { text: 'Monthly Reconciliation', redirection: routeConstants.MONTHLY_RECONCILIATION_ROUTE },
                { text: breadcrumbSecondLabel },
              ]}
            />
          </Box>
        )}
        <Box component="div" className={embedInOpenTab ? '' : classes.mainPaper} sx={embedInOpenTab ? { pb: 1 } : {}}>
          <MonthlyReconciliationControlPanel classes={classes} {...controlPanelProps} />
          <MonthlyReconciliationSummary classes={classes} {...summaryProps} />
        </Box>

        <MonthlyReconciliationResults classes={classes} {...resultsProps} />
        <MonthlyFinalizeDialogs {...finalizeDialogProps} />
      </React.Fragment>

      <MonthlyValidationDialog {...validationDialogProps} />
    </>
  );
};

export default MonthlyReconciliationDetail;
